import { Validators, FormBuilder } from '@angular/forms';

export const FORM_ADDRESS_BERAU = function (fb: FormBuilder) {

  return fb.group({
    calle: ['', [Validators.required]],
    numExt: ['', [Validators.required]],
    numInt: [''],
    cp: ['', [Validators.required, Validators.pattern('^[0-9]{4,5}$')]],
    colonia: ['', [Validators.required]],
    coloniaDesc: [''],
    stateId: [],
    stateDesc: [''],
    cityId: [''],
    otherCityDesc: [''],
    municipality: [''],
    betweenStreets: [''],
    countryId: [''],
    countryDesc: [''],
    idAsentaCpConst: ['']
  });

}
